import React from 'react';

import { Switch, Route } from 'react-router-dom';

// pages
import {
  AsyncLoginMain,
  AsyncDashboard,
  AsyncTermsAndConditionsOfUse,
  AsyncResetPassword,
  AsyncNotFound,
} from './pages';

// pages Admin
import {
  AsyncPermissionsAdmin,
  AsyncUser,
  AsyncUsers,
  AsyncCreateUser,
  AsyncClientAreaUserServiceAssignment,
  AsyncBrokers,
  AsyncDepartments,
  AsyncPositions,
  AsyncGroups,
  AsyncCreateLoanApplication,
} from './pages/Admin';

// pages Loan Applications
import { AsyncValidationLoanApplications } from './pages/LoanApplication';

// pages loans
import { AsyncLoans, AsyncLateLoans } from './pages/LoanModule';

// InOutBalance
import {
  AsyncMovements,
  AsyncMovementsSummary,
  AsyncBankAccounts,
  AsyncBankAccount,
} from './pages/InOutBalance';

// Investment
import {
  AsyncProducts,
  AsyncEditCreateProduct,
  AsyncWalletUsers,
  AsyncEditUser,
  AsyncUserProducts,
  AsyncCreateEditUserProductAccount,
} from './pages/Investment';

// tables
import { AsyncLoanApplications } from './tables/reactable';

import ProtectedRoute from './components/HOC/ProtectedRoute';

const Routes = () => (
  <Switch>
    {/* LOAN APPLICATIONS AND LOANS */}
    <ProtectedRoute path="/solicitudes/" component={AsyncLoanApplications} />

    <Route path="/reset-password/:token" component={AsyncResetPassword} />

    <ProtectedRoute path="/legal-prestamos" component={AsyncLateLoans} />
    <ProtectedRoute path="/prestamos" component={AsyncLoans} />
    <ProtectedRoute
      path="/validacion"
      component={AsyncValidationLoanApplications}
    />

    {/* ADMIN */}
    <ProtectedRoute path="/crear-usuario" component={AsyncCreateUser} />
    <Route path="/iniciar-sesion" component={AsyncLoginMain} />
    <ProtectedRoute path="/usuario/:userId" component={AsyncUser} />
    <ProtectedRoute path="/usuarios" component={AsyncUsers} />
    <ProtectedRoute
      path="/usuario-servicio/:serviceType/:serviceId/:email"
      component={AsyncClientAreaUserServiceAssignment}
    />
    <ProtectedRoute path="/permisos" component={AsyncPermissionsAdmin} />
    <ProtectedRoute path="/corredores" component={AsyncBrokers} />
    <ProtectedRoute path="/departamentos" component={AsyncDepartments} />
    <ProtectedRoute path="/posiciones" component={AsyncPositions} />
    <ProtectedRoute path="/grupos" component={AsyncGroups} />
    <ProtectedRoute
      path="/crear-solicitud"
      component={AsyncCreateLoanApplication}
    />

    {/* IN OUT BALANCE */}
    <ProtectedRoute path="/movimientos" component={AsyncMovements} />
    <ProtectedRoute
      path="/resumen-movimientos"
      component={AsyncMovementsSummary}
    />
    <ProtectedRoute path="/cuentas-bancarias" component={AsyncBankAccounts} />
    <ProtectedRoute
      path="/cuentas-bancarias/:bankAccountId"
      component={AsyncBankAccount}
    />

    {/* INVESTMENT */}
    <ProtectedRoute
      path="/products/:productId/edit"
      component={AsyncEditCreateProduct}
    />
    <ProtectedRoute path="/products/new" component={AsyncEditCreateProduct} />
    <ProtectedRoute path="/products" component={AsyncProducts} />
    <ProtectedRoute
      path="/users/:userId/accounts/:productId/edit"
      component={AsyncCreateEditUserProductAccount}
    />
    <ProtectedRoute
      path="/users/:userId/accounts/new"
      component={AsyncCreateEditUserProductAccount}
    />
    <ProtectedRoute
      path="/users/:userId/accounts/"
      component={AsyncUserProducts}
    />
    <ProtectedRoute path="/users/edit" component={AsyncEditUser} />
    <ProtectedRoute path="/users" component={AsyncWalletUsers} />
    <Route path="/terms" component={AsyncTermsAndConditionsOfUse} />
    <ProtectedRoute exact path="/" component={AsyncDashboard} />
    <Route component={AsyncNotFound} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js